import angular = require('angular');
import moment = require('moment');
import { IInclusaodependente } from '../../models/inclusaodependente.model';
import {
    contaBancoValida,
    getMensagemContaBanco,
    digitoVerificadorContaValido,
    getMensagemDigitoVerificador,
    TipoPagamentoEnum
} from '../../../../../utils/dados-bancarios';
import { TipoContaPixEnum } from '../../../../../shared/enums/TipoContaPixEnum';

export class MeurhInclusaodependenteOutrasinformacoesFormController implements ng.IController {

    static $inject = ['$scope', '$element', '$attrs', 'NewToaster', '$rootScope', '$sce', 'Paises'];

    public entity: IInclusaodependente;
    public form: angular.IFormController;
    public constructor_: any = {};
    public action: any;

    public agenciaNumero: any = 'numero';

    public exibeAlertaConta: boolean = false;
    public focoInputConta: boolean = false;

    public exibeAlertaDigitoVerificador: boolean = false;
    public focoInputDigitoVerificador: boolean = false;

    public tiposPagamentoChecaDv = [
        TipoPagamentoEnum.CONTA_CORRENTE,
        TipoPagamentoEnum.CONTA_POUPANCA,
        TipoPagamentoEnum.CONTA_SALARIO,
        TipoPagamentoEnum.PIX_AGENCIA_CONTA
    ];

    public tipoContaPixEnum = TipoContaPixEnum;

    constructor(
        public $scope: angular.IScope,
        public $element: any,
        public $attrs: any,
        public NewToaster: any,
        public $rootScope: angular.IRootScopeService & { configuracoes: any, session: any },
        public $sce: angular.ISCEService,
        public Paises: any,
    ) {

    }

    $onInit(): void {
        this.constructor_ = this.verificacaoBanco();

        // no show, o nome do campo referente ao número da agência é diferente do da listagem no new/edit
        if (this.action === 'show') {
            this.agenciaNumero = 'agencianumero';
        } else {
            this.agenciaNumero = 'numero';
            if (this.action === 'update' && this.entity.agencia) {
                this.entity.agencia.numero = this.entity.agencia.agencianumero;
            }
        }
    }

    preencheCampo(): void {

        if (this.entity.tiporecebimento !== '64') {
            this.entity.tipocontapix = null;
        }

        if (this.entity.tiporecebimento === '128') { // cpf
            this.entity.chavepix = this.entity.cpf;
        } else if (this.entity.tiporecebimento === '256') { // email
            this.entity.chavepix = this.entity.email;
        } else if (this.entity.tiporecebimento === '512') { // celular
            this.entity.chavepix = this.entity.dddcel + this.entity.celular;
        } else {
            this.entity.chavepix = '';
        }
    }

    verificacaoBanco(): { banco: string } {
        if (this.entity.banco) {
            if (this.entity.banco.banco) {
                return { 'banco': this.entity.banco.banco };
            }
        }
        return { 'banco': null };
    }

    alteraAgenciaPorBanco(): void {
        if (this.entity.banco) {
            this.$rootScope.$broadcast('agencia_refresh', { banco: this.entity.banco.banco });
            this.entity.agencia = null;
        }
    }

    changeBanco(): void {
        this.limpaDadosAgenciaConta();
        this.alteraAgenciaPorBanco();
        this.constructor_ = this.verificacaoBanco();
    }

    limpaCamposEhBeneficiariopensao(): void {
        if (this.entity.pensaoalimenticia === false ) {
            delete this.entity.tiporecebimento;
            delete this.entity.banco;
            delete this.entity.chavepix;
            delete this.entity.agencia;
            delete this.entity.numerocontasalario;
            delete this.entity.numerocontasalariodv;
            delete this.entity.percentualpensaoalimenticia;
            delete this.entity.percentualpensaoalimenticiafgts;
        }
    }

    public limpaDadosAgenciaConta() {
        this.entity.agencia = null;
        this.entity.numeroconta = null;
        this.entity.numerocontadv = null;
    }

    public limpaBanco() {
        this.entity.banco = null;
    }

    public validaContaPagamento() {
        if (!this.entity.banco || !this.entity.tiporecebimento || !this.entity.numeroconta) {
            this.exibeAlertaConta = false;
            return;
        }

        this.exibeAlertaConta = !contaBancoValida(this.entity.banco, this.entity.tiporecebimento, this.entity.numeroconta, this.entity.tipocontapix) &&
            !this.form.numeroconta?.$error?.required &&
            this.action !== 'show';
    }

    public verificaExibicaoAlertaConta() {
        if (!this.entity.banco || !this.entity.tiporecebimento || !this.entity.numeroconta) {
            return false;
        }

        return !this.focoInputConta && this.exibeAlertaConta;
    }

    public getMensagemAlertaConta(): string {
        return getMensagemContaBanco(this.entity.banco, this.entity.tiporecebimento, this.entity.numeroconta, this.entity.tipocontapix);
    }

    public validaDigitoVerificadorConta() {
        if (!this.entity.banco || !this.entity.tiporecebimento || !this.entity.numerocontadv) {
            this.exibeAlertaDigitoVerificador = false;
            return;
        }

        this.exibeAlertaDigitoVerificador = !digitoVerificadorContaValido(this.entity.banco, this.entity.tiporecebimento, this.entity.numerocontadv, this.entity.tipocontapix) &&
            !this.form.numerocontadv?.$error?.required &&
            this.action !== 'show';
    }

    public verificaExibicaoAlertaDigitoVerificador() {
        if (!this.entity.banco || !this.entity.tiporecebimento || !this.entity.numerocontadv) {
            return false;
        }

        return !this.focoInputDigitoVerificador && this.exibeAlertaDigitoVerificador;
    }

    public getMensagemAlertaDigitoVerificador(): string {
        return getMensagemDigitoVerificador(this.entity.banco, this.entity.tiporecebimento, this.entity.numerocontadv, this.entity.tipocontapix);
    }

}
